<script setup lang="ts">
    import { useFilterStoreByName } from '@/js/stores/filter';
    import CheckboxFilter from './CheckboxFilter.vue';
    import { __ } from '@/js/stores/expressions';
    import EnumToggleSwitch from '../EnumToggleSwitch.vue';
    import { FilterStoreName } from '@/js/services/api/filter/types';
    import { showTrackerGroupTypeToggle } from './types';

    const props = defineProps<{
        filterStoreName: FilterStoreName;
    }>();

    const filter = useFilterStoreByName(props.filterStoreName);

    const mappedAvailableGroupTypes = (filter.all?.trackerFilter?.availableGroupTypes ?? []).map(
        (type) => {
            return {
                value: type,
                label: type,
            };
        }
    );
</script>

<template>
    <div v-if="showTrackerGroupTypeToggle && filter.all?.trackerFilter" class="mx-4 mb-4 mt-2">
        <EnumToggleSwitch
            v-if="filter.all?.trackerFilter?.availableGroupTypes"
            id="trackerFilterGroupType"
            v-model="filter.all.trackerFilter.selectedGroupType"
            :spread="true"
            :items="mappedAvailableGroupTypes"
        />
    </div>

    <CheckboxFilter v-if="filter.all?.trackerFilter" :checkboxes="filter.all.trackerFilter.filter">
        {{ __('tracker') }}
    </CheckboxFilter>
</template>
